<div
  class="tw-flex tw-flex-col tw-border tw-border-gray-200 tw-rounded-lg tw-bg-white"
  [ngClass]="{ '!tw-border-blue-400': isExpanded(), 'lg:tw-hidden': !showOnDesktop() }"
>
  <button
    type="button"
    class="tw-w-full tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-5 tw-text-left tw-gap-3 tw-rounded-t-[8px]"
    (click)="toggleSection()"
    [attr.aria-expanded]="isExpanded()"
    [ngClass]="{ 'tw-bg-blue-50 tw-border-b': isExpanded() }"
  >
    <div class="tw-flex tw-items-center tw-gap-3">
      <ng-content select="[collapsibleIcon]"></ng-content>
      <h3 class="tw-text-gray-900 tw-text-sm tw-font-bold tw-leading-none">{{ title() }}</h3>
    </div>

    <svg class="expand-arrow" [ngClass]="{ expanded: isExpanded() }" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
      <g clip-path="url(#collapsible_arrow_clip)">
        <path
          d="M3.67863 12C3.44839 11.9999 3.22332 11.9296 3.0319 11.7979C2.84047 11.6662 2.69128 11.4791 2.60317 11.2601C2.51507 11.0411 2.49201 10.8002 2.53692 10.5677C2.58182 10.3353 2.69267 10.1217 2.85546 9.95411L6.68957 6.00736L2.85546 2.06061C2.74425 1.95005 2.65555 1.8178 2.59453 1.67158C2.53351 1.52535 2.50139 1.36808 2.50004 1.20894C2.4987 1.0498 2.52816 0.89198 2.5867 0.744686C2.64525 0.597391 2.7317 0.463573 2.84102 0.35104C2.95034 0.238507 3.08034 0.149513 3.22343 0.0892499C3.36653 0.0289869 3.51984 -0.00133763 3.67444 4.52529e-05C3.82904 0.00142813 3.98182 0.034491 4.12387 0.0973047C4.26593 0.160118 4.3944 0.251425 4.50181 0.365896L9.1591 5.16001C9.37738 5.38476 9.5 5.68956 9.5 6.00736C9.5 6.32517 9.37738 6.62997 9.1591 6.85472L4.50181 11.6488C4.28351 11.8736 3.9874 11.9999 3.67863 12Z"
          fill="#1C64F2"
        />
      </g>
      <defs>
        <clipPath id="collapsible_arrow_clip">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </button>

  <div class="collapsible-body" [class.expanded]="isExpanded()" [attr.aria-hidden]="!isExpanded()">
    <div class="collapsible-body-inner tw-py-4 tw-px-3 tw-bg-white tw-rounded-lg">
      <ng-content select="[collapsibleBody]"></ng-content>
    </div>
  </div>
</div>
